define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/table/Widget"
], function(declare,locale,Widget) {

	return declare(Widget, {
		postCreate: function() {
			// summary: show warning message if WbsRequest is pending
			this.inherited(arguments);
			this.invalidNode.set("bold", true);
			this.invalidNode.set("value", locale.resource("PruneWarning"));
		}
	});
});
